import React, { useEffect } from 'react';
import { MdCheckCircle, MdError, MdInfo, MdWarning, MdClose } from 'react-icons/md';

const Toast = ({ message, type = 'success', onClose, duration = 3000 }) => {
  useEffect(() => {
    if (duration > 0) {
      const timer = setTimeout(() => {
        onClose();
      }, duration);
      return () => clearTimeout(timer);
    }
  }, [duration, onClose]);

  const getIcon = () => {
    switch (type) {
      case 'success':
        return <MdCheckCircle size={20} />;
      case 'error':
        return <MdError size={20} />;
      case 'warning':
        return <MdWarning size={20} />;
      case 'info':
        return <MdInfo size={20} />;
      default:
        return <MdCheckCircle size={20} />;
    }
  };

  const getColors = () => {
    switch (type) {
      case 'success':
        return {
          bg: 'rgba(52, 199, 89, 0.95)',
          icon: '#fff'
        };
      case 'error':
        return {
          bg: 'rgba(255, 59, 48, 0.95)',
          icon: '#fff'
        };
      case 'warning':
        return {
          bg: 'rgba(255, 204, 0, 0.95)',
          icon: '#1c1c1e'
        };
      case 'info':
        return {
          bg: 'rgba(0, 122, 255, 0.95)',
          icon: '#fff'
        };
      default:
        return {
          bg: 'rgba(52, 199, 89, 0.95)',
          icon: '#fff'
        };
    }
  };

  const colors = getColors();

  return (
    <div
      style={{
        position: 'fixed',
        top: '24px',
        right: '24px',
        zIndex: 9999,
        display: 'flex',
        alignItems: 'center',
        gap: '12px',
        padding: '16px 20px',
        background: colors.bg,
        backdropFilter: 'blur(20px)',
        WebkitBackdropFilter: 'blur(20px)',
        borderRadius: '16px',
        boxShadow: '0 8px 32px rgba(0, 0, 0, 0.2), 0 2px 8px rgba(0, 0, 0, 0.1)',
        color: colors.icon,
        fontWeight: 500,
        fontSize: '0.95rem',
        minWidth: '300px',
        maxWidth: '500px',
        animation: 'slideInFromRight 0.3s ease-out',
        cursor: 'pointer'
      }}
      onClick={onClose}
    >
      <div style={{ color: colors.icon }}>
        {getIcon()}
      </div>
      <div style={{ flex: 1 }}>
        {message}
      </div>
      <button
        onClick={(e) => {
          e.stopPropagation();
          onClose();
        }}
        style={{
          background: 'transparent',
          border: 'none',
          color: colors.icon,
          cursor: 'pointer',
          padding: '4px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          borderRadius: '6px',
          opacity: 0.8,
          transition: 'opacity 0.2s'
        }}
        onMouseEnter={(e) => e.target.style.opacity = '1'}
        onMouseLeave={(e) => e.target.style.opacity = '0.8'}
      >
        <MdClose size={18} />
      </button>
      <style>{`
        @keyframes slideInFromRight {
          from {
            transform: translateX(100%);
            opacity: 0;
          }
          to {
            transform: translateX(0);
            opacity: 1;
          }
        }
      `}</style>
    </div>
  );
};

export default Toast;
